<template>
  <div class="SideBarBox">
    <div class="sideContent">
      <div
        :class="navShow ? 'open' : 'close'"
        style="align-self:center"
        ref="open"
        @click="spread"
      >
        <img class="spread" src="~images/dic.png" />
      </div>
      <transition name="el-fade-in-linear">
        <div style="display:flex" v-show="navShow">
          <div
            class="list"
            @click="listClick(item, index)"
            v-for="(item, index) in list"
            :class="{ checked: index == groupcheck }"
            :key="index"
            @mouseout="hiddenTips(item.name)"
            @mouseover="showTips(item.name)"
          >
            <!-- <span
              class="noTips"
              :style="item.name === '市场环境' ? '' : 'color:rgba(0,0,0,0)'"
              v-if="noTips"
              >功能开发中...</span
            > -->
            <img
              class="sideImg"
              :src="index == groupcheck ? item.activeImg : item.inactiveImg"
            />
            <p class="sideName">{{ item.name }}</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      navShow: true,
      groupcheck: 0,
      list: this.$config.SideBar,
      noTips: false
    };
  },
  methods: {
    listClick(item, index) {
      // if (item.code === "schj") {
      //   return false;
      // } else {
      if (this.groupcheck === index) return;
      this.$emit("boxshow", item.code);
      this.groupcheck = index;
      // }
      if (item.code === "schj") {
        return false;
      } else {
        if (this.groupcheck === index) return;
        this.$emit("boxshow", item.code);
        this.groupcheck = index;
      }
    },
    spread() {
      this.navShow = !this.navShow;
    },
    showTips(name) {
      if (name == "市场环境") {
        this.noTips = true;
      }
    },
    hiddenTips(name) {
      if (name == "市场环境") {
        this.noTips = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/largeScreen/SideBar'
@import '~styl/smallScreen/SideBar'

.list
  position relative

.noTips
  position absolute
  bottom 100%
  left 50%
  transform translate(-50%, -50%)
  display inline-block
  width 130%
</style>
